import { render, staticRenderFns } from "./DetailAnotation.vue?vue&type=template&id=0dd9db79&"
import script from "./DetailAnotation.vue?vue&type=script&lang=js&"
export * from "./DetailAnotation.vue?vue&type=script&lang=js&"
import style0 from "./DetailAnotation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports